import { Pipe, PipeTransform } from '@angular/core'

const MAX_STARS = 5

@Pipe({
  name: 'starRating',
})
export class StarRatingPipe implements PipeTransform {
  // Returns an array of length MAX_STARS where a truthy entry means "filled star".
  // A pure pipe so it only recomputes when `count` changes, instead of reallocating
  // a new array on every change-detection cycle like a method call in the template would.
  transform(count: number | null): boolean[] {
    const filled = Math.min(Math.max(count ?? 0, 0), MAX_STARS)
    return Array.from({ length: MAX_STARS }, (_, i) => i < filled)
  }
}
